import React from 'react';

// Panel kiri halaman masuk/daftar Starhub Creative (2026-10-22): latar api, stiker logo, logo platform asli.
export default function AuthHero() {
  return (
    <aside className="sh-auth-hero" aria-hidden="true">
      <img className="sh-auth-watermark" src="/emblem-on-fire.png" alt="" />
      <img className="sh-auth-sticker" src="/emblem-sticker.png" alt="" />
      <h2>Satu klik,<br /><span>semua channel</span><br />langsung jalan.</h2>
      <p>Upload, jadwalkan, dan pantau konten di banyak channel dari satu tempat.</p>
      <div className="sh-auth-plat">
        <span><img src="/brand/youtube.svg" alt="" />YouTube</span>
        <span><img src="/brand/tiktok.svg" alt="" />TikTok</span>
        <span><img src="/brand/instagram.svg" alt="" />Instagram</span>
      </div>
      <div className="sh-auth-tags"><b>✦ kompilasi lagu</b><b>✦ multi-bahasa</b><b>✦ kerja tim</b></div>
    </aside>
  );
}
